import React from "react"
import {useTranslation} from "react-i18next"

// Components
import Icon from "../../../../../components/modern/Icon"

// Styles
import useStyles from "./styles"

export type ModernMobileTab = "details" | "conclusion"

const TABS: ModernMobileTab[] = ["conclusion", "details"];

type ModernRecordMobileProps = {
    toolbar: React.ReactNode
    stage: React.ReactNode
    details: React.ReactNode
    conclusion: React.ReactNode
    tab: ModernMobileTab
    onTabChange(tab: ModernMobileTab): void
    showApprove: boolean
    approveDisabled: boolean
    onApprove(): void
    onApproveNext(): void
}

export default function ModernRecordMobile(props: ModernRecordMobileProps) {
    const styles = useStyles();
    const [t] = useTranslation("common");
    const {
        toolbar,
        stage,
        details,
        conclusion,
        tab,
        onTabChange,
        showApprove,
        approveDisabled,
        onApprove,
        onApproveNext,
    } = props;

    return (
        <React.Fragment>
            {toolbar}

            <div className={styles.tabs} role="tablist">
                {TABS.map(key => (
                    <button
                        key={key}
                        type="button"
                        role="tab"
                        aria-selected={tab === key}
                        className={`${styles.tab} ${tab === key ? styles.tab__active : ""}`}
                        onClick={() => onTabChange(key)}
                    >
                        {t(`modern.tabs.${key}`)}
                    </button>
                ))}
            </div>

            <div
                className={`${styles.panel} ${styles.panel__cards}`}
                role="tabpanel"
                hidden={tab !== "conclusion"}
            >
                {conclusion}
            </div>

            <div
                className={`${styles.panel} ${styles.panel__cards}`}
                role="tabpanel"
                hidden={tab !== "details"}
            >
                {details}
            </div>

            <div className={styles.stage}>
                {stage}
            </div>

            {showApprove && (
                <div className={styles.actions}>
                    <button
                        type="button"
                        className={`${styles.btn} ${styles.btn__approve}`}
                        disabled={approveDisabled}
                        title={approveDisabled ? t("modern.approve_blocked") : undefined}
                        onClick={onApprove}
                    >
                        <Icon name="check"/>
                        {t("approve")}
                    </button>
                    <button
                        type="button"
                        className={`${styles.btn} ${styles.btn__approve_next}`}
                        disabled={approveDisabled}
                        title={approveDisabled ? t("modern.approve_blocked") : undefined}
                        onClick={onApproveNext}
                    >
                        <Icon name="check"/>
                        {t("modern.approve_next")}
                    </button>
                </div>
            )}
        </React.Fragment>
    )
}
